import scheduleFiveIndividualCombined from './schedule-five-overview-filters';
import scheduleFiveIndividualCombinedElements, { refreshIndividualGrid, getIndividualGrid } from './schedule-five-individual-combined-elements';
import { initTotalsGrid, refreshTotalsGrid, getTotalsGrid } from './schedule-five-totals-elements';
import scheduleFiveUpsideOverview, { refreshUpsideDownsideGrid, getUpsideDownsideGrid } from './schedule-five-upside-elements';
import { initPrevMonthGrid, refreshPrevMonthGrid, getPrevMonthGrid } from './schedule-five-previous-month-elements';
import { initVarianceGrid, refreshVarianceGrid, getVarianceGrid } from './schedule-five-variance-elements';
import { initCostCodeGrid, getCostCodeRawData } from './schedule-five-cost-code-elements';
import { buildCostCodeSheet } from './schedule-five-cost-code-export';
import { initSummaryFilterCoordinator, syncScrolls } from './schedule-five-summary-shared';
import _bundle from '../../../../core/core--bundles';
import gridExport from '../../../global/grid-export';
import { exportSummaryToExcel } from './schedule-five-summary-export';

let _individualInit = false;
let _unassignedInit = false;
let _upsideInit = false;
let _summaryInit = false;

const individualTabKey = 'individual';
const unassignedTabKey = 'unassigned';
const upsideDownsideTabKey = 'upside-downside';
const summaryTabKey = 'summary';

const addEvents = () => {
    _bundle.add({
        name: 'Schedule Five Overview: Change Tabs',
        event: ['on:TabChange'],
        fn() {
            const activeTabKey = $('.menu-topbar__link.--active').data('tabkey');
            loadTab(activeTabKey);
        },
    });

    // Click handler to suppress the # navigation
    $('.menu-topbar__link').bind('click', function(e) {
        e.preventDefault();
    });
};

let _exportDdl = null;

export default function() {
    const activeTab = $('.menu-topbar__link.--active').data('tabkey');
    _exportDdl = gridExport('.js-export-select', getActiveGrid, onSummaryExport);
    loadTab(activeTab, true);
}

const loadTab = function(tabKey, addEventsAfterInit) {
    if (tabKey === individualTabKey) {
        if (_individualInit) {
            setTimeout(refreshIndividualGrid, 250);
        } else initIndividualTab();
    } else if (tabKey === upsideDownsideTabKey) {
        initUpsideTab();
    } else if (tabKey === summaryTabKey) {
        initSummaryTab();
    }

    if (addEventsAfterInit) {
        addEvents();
    } else {
        const exportVisible = tabKey === individualTabKey || tabKey === upsideDownsideTabKey || tabKey === summaryTabKey;
        $('.k-widget.k-dropdown.js-export-select').css('visibility', exportVisible ? 'visible' : 'hidden');
    }

    if (_exportDdl) {
        const items = tabKey === summaryTabKey
            ? [{ text: 'Excel', value: 1 }]
            : [{ text: 'Excel', value: 1 }, { text: 'CSV', value: 2 }];
        _exportDdl.dataSource.data(items);
    }
};

const initIndividualTab = () => {
    scheduleFiveIndividualCombinedElements();
    scheduleFiveIndividualCombined();
    _individualInit = true;
};

const getActiveGrid = () => {
    const activeTabKey = $('.menu-topbar__link.--active').data('tabkey');
    if (activeTabKey === individualTabKey) return getIndividualGrid();
    if (activeTabKey === upsideDownsideTabKey) return getUpsideDownsideGrid();
    return null;
};

const onSummaryExport = () => {
    const activeTabKey = $('.menu-topbar__link.--active').data('tabkey');
    if (activeTabKey !== summaryTabKey) return;
    exportSummaryToExcel([
        { grid: getTotalsGrid(), sheetName: 'Current Month' },
        { grid: getPrevMonthGrid(), sheetName: 'Previous Month' },
        { grid: getVarianceGrid(), sheetName: 'Variance' },
        { sheet: buildCostCodeSheet(getCostCodeRawData()) },
    ]);
};

const initUpsideTab = () => {
    if (!_upsideInit) {
        scheduleFiveUpsideOverview();
    }
    else {
        refreshUpsideDownsideGrid();
    }

    _upsideInit = true;
};

const initSummaryTab = () => {
    if (_summaryInit) {
        refreshTotalsGrid();
        refreshPrevMonthGrid();
        refreshVarianceGrid();
    } else {
        const company = $('.grid.totals-grid').data('company');
        initSummaryFilterCoordinator(company);
        Promise.all([initTotalsGrid(), initPrevMonthGrid(), initVarianceGrid(), initCostCodeGrid()])
            .then(() => syncScrolls(
                '.s5-totals-wrap .k-grid-content',
                '.s5-previous-month-wrap .k-grid-content',
                '.s5-variance-wrap .k-grid-content',
                '.s5-cost-code-wrap .k-grid-content'
            ));
    }

    _summaryInit = true;
};
